export default "__VITE_ASSET__DfcuyYEU__"